import { Runtype, Unknown } from "runtypes";

import { CellType } from "./enums.js";

export enum ESDocType {
  HEX = "hex",
  APP = "app",
}

// Constructs runtypes from an enum value.
// See https://github.com/pelotom/runtypes/issues/66#issuecomment-788129292
export const runtypeFromEnum = <EnumType>(
  theEnum: Record<string, EnumType>,
): Runtype<EnumType> => {
  const values = Object.values<unknown>(theEnum);
  const isEnumValue = (input: unknown): input is EnumType =>
    values.includes(input);
  const errorMessage = (input: unknown): string =>
    `Failed constraint check. Expected one of ${JSON.stringify(
      values,
    )}, but received ${JSON.stringify(input)}`;
  return Unknown.withConstraint<EnumType>(
    (object: any) => isEnumValue(object) || errorMessage(object),
  );
};

export const ESDocTypeRuntype = runtypeFromEnum(ESDocType);
export const CellTypeRuntype = runtypeFromEnum(CellType);
